export default {
    searching: 'Procurando...',
    loading: 'Carregando...',
    button_edit: 'Editar',
    button_cancel: 'Cancelar',
    button_close: 'Fechar',
    button_delete: 'Deletar',
    button_restore: 'Restaurar',
    button_view: 'Visualizar',
    button_view_board: 'Ver no Quadro',
    button_add: 'Adicionar',
    button_revoke: 'Revogar',
    button_finish_workload: 'Finalizar Atividade',
    card_not_loaded: 'Desculpe, não foi possível carregar o conteúdo',
    resources: {
        workload: 'Carga de Trabalho'
    },
    total: 'Total',
    yes: 'Sim',
    no: 'Não',
    without_category: 'Sem Categoria',
    call: 'Chamado',
    calls: 'Chamados',
    attendance_group: 'Grupo de Atendimento',
    task: 'Tarefa',
    item_checklist: 'Item do Checklist',
    tasks: 'Tarefas',
    call_archived: 'Chamado está arquivado',
    task_archived: 'Tarefa está arquivada',
    most_recent: 'Mais Recentes',
    older: 'Mais Antigos',
    verified: 'Verificado',
    not_verified: 'Não Verificado',
    period: 'Período',
    duration: 'Duração',
    total_time: 'Tempo Total',
    attendants: 'Atendentes',
    running_activity: 'Atividade em Execução',
    main_account_user: 'Usuário principal da conta',
    created_at: 'Data de Criação',
    author: 'Autor',
    user: 'Usuário',
    filters: 'Filtros',
    no_filter: 'Nenhum Filtro',
    download_all: 'Baixar Todos',
    unlimited: 'Ilimitado',
    answer: 'Atender',
    accept: 'Aceitar',
    ignore: 'Ignorar',
    refuse: 'Recusar',
    no_attendant: 'Sem Atendente',
    time_left: 'Restante {{date}}',
    time_exceeded: 'Excedeu {{date}}',
    task_count_zero: '0 Tarefas',
    task_count_one: '1 Tarefa',
    task_count_other: '{{count}} Tarefas',
    ticket_count_zero: '0 Chamados',
    ticket_count_one: '1 Chamado',
    ticket_count_other: '{{count}} Chamados',
    responsible_count_zero: '0 Responsáveis',
    responsible_count_one: '1 Responsável',
    responsible_count_other: '{{count}} Responsáveis',
    free: 'Gratuito',
    is_plan_default: 'Plano padrão',
    days_count_zero: 'Nenhum dia',
    days_count_one: '1 dia',
    days_count_other: '{{count}} dias',
    billing_frequency_month_one: 'mensal',
    billing_frequency_month_other: 'a cada {{count}} meses',
    billing_frequency_year: 'anual',
    here: 'aqui',
    added_on: 'Adicionado em {{date}}',
    expires_on: 'Expira em {{date}}',
}
